import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import Text, { TextType } from '../../Text/Text';
import { classes } from './BookForSomeoneElseBanner.st.css';

const BookForSomeoneElseBanner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={classes.root} role="note">
      <Text type={TextType.Primary} tagName="p" className={classes.title}>
        {t('bookings.form.bookForSomeoneElse.banner.title')}
      </Text>
      <Text type={TextType.Primary} tagName="p" className={classes.body}>
        {t('bookings.form.bookForSomeoneElse.banner.body')}
      </Text>
    </div>
  );
};

export default BookForSomeoneElseBanner;
